const getLoanNumberByContent = data => {
  if (data) {
    const {
      content,
      metadata
    } = data;
    const regex = /\[(.*?)\]/g;
    const replacedText = content?.replace(regex, (_, placeHolder) => {
      if (metadata?.values && metadata.values[placeHolder]) {
        return metadata.values[placeHolder];
      } else {
        return `[${placeHolder}]`;
      }
    });
    return replacedText;
  }
};
const getAlertSubbodyContent = ({
  content,
  metadata
}) => {
  if (content && metadata?.values) {
    Object.keys(metadata.values).forEach(placeholder => {
      const placeholderValue = metadata.values[placeholder];
      const regex = new RegExp(`\\[${placeholder}\\]`, 'g');
      content = content?.replace(regex, placeholderValue);
    });
    return content;
  }
  return content;
};
const getSubbodyByContent = data => {
  if (data) {
    const {
      currentStep,
      totalSteps,
      currentStepName
    } = data;
    const output = `Step ${currentStep}/${totalSteps}: ${currentStepName}`;
    return output;
  }
  return null;
};
const Functions = {
  getLoanNumberByContent,
  getAlertSubbodyContent,
  getSubbodyByContent
};
export default Functions;
//# sourceMappingURL=TileCard.util.js.map